<!-- <iframe width="100%" height="100%" [src]="shibbolethLogoutUrl | safe" aria-hidden="true"></iframe> -->
<div class="sign-in-box-container">
  <div class="sign-in-box-inner-container">
    <div class="logo-box p-g-12 p-md-6 p-lg-6 p-g-nopad p-md-offset-1 p-lg-offset-1 p-g-offset-1">
      <div>
        <div class="form-field p-g-4 p-g-nopad">
          <img src='/assets/images/temp/nbx_login_logo.svg' alt="logo">
        </div>
        <div class="logo-box">
          <div class="form-field p-g-11 p-g-nopad">
              <h2>The Braunfels Express Shuttle team is updating the system. We apologize for the inconvenience. Please visit the site
                again after an hour.</h2>
            <div>
              <div class="form-field p-g-3 p-g-nopad">
                <button pButton class='sign-in-buttons' (click)="onLogin()" label="Login"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
